import React, { useState, useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { getImageUrl, imageSize } from '../services/tmdb';
import { Button } from './ui/button';

const ContentRow = ({ title, fetchFunction, onSelectContent }) => {
  const [content, setContent] = useState([]);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const scrollRef = useRef(null);

  useEffect(() => {
    loadContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadContent = async () => {
    const data = await fetchFunction();
    setContent(data);
  };

  const scroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;

    const scrollAmount = container.offsetWidth * 0.8;
    const newScrollLeft = direction === 'left'
      ? container.scrollLeft - scrollAmount
      : container.scrollLeft + scrollAmount;

    container.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth'
    });
  };

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;

    setShowLeftArrow(container.scrollLeft > 0);
    setShowRightArrow(
      container.scrollLeft < container.scrollWidth - container.offsetWidth - 10
    );
  };

  if (!content || content.length === 0) return null;

  return (
    <div className="relative group px-8 md:px-16 lg:px-24 py-6">
      <h2 className="text-xl md:text-2xl font-semibold text-white mb-4">
        {title}
      </h2>

      {/* Left Arrow */}
      {showLeftArrow && (
        <Button
          onClick={() => scroll('left')}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-10 h-full bg-black/60 hover:bg-black/80 text-white px-2 rounded-none opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          variant="ghost"
        >
          <ChevronLeft className="h-10 w-10" />
        </Button>
      )}

      {/* Content Scroll Container */}
      <div
        ref={scrollRef}
        onScroll={handleScroll}
        className="flex gap-2 overflow-x-scroll scrollbar-hide scroll-smooth"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {content.map((item) => {
          const posterUrl = getImageUrl(item.poster_path, imageSize.poster);
          const title = item.title || item.name;

          return (
            <div
              key={item.id}
              onClick={() => onSelectContent(item)}
              className="flex-none w-36 md:w-48 cursor-pointer transform transition-all duration-300 hover:scale-110 hover:z-10"
            >
              <div className="relative rounded overflow-hidden shadow-lg">
                <img
                  src={posterUrl}
                  alt={title}
                  className="w-full h-54 md:h-72 object-cover"
                  onError={(e) => {
                    e.target.src = '/placeholder-movie.svg';
                  }}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <p className="text-white text-sm font-semibold p-3 line-clamp-2">
                    {title}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Right Arrow */}
      {showRightArrow && (
        <Button
          onClick={() => scroll('right')}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-10 h-full bg-black/60 hover:bg-black/80 text-white px-2 rounded-none opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          variant="ghost"
        >
          <ChevronRight className="h-10 w-10" />
        </Button>
      )}
    </div>
  );
};

export default ContentRow;